export default __webpack_public_path__ + "static/media/screen9.42a8ec9f.svg";